import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { util } from '../../../classes/util';
import { environment } from '../../../environment';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { FillStyleOptions, LineStyleOptions } from '../../../selectionOptions';
import { LayerService } from '../../../services/layer.service';
import { PrintService } from '../../../services/print.service';
import { BaseComponent } from '../../base.component';
var RadiusOffsetDivisor = 3.2;
var initilizeDebounceTime = 50;
var Draw;
var Graphic;
var GeometryService;
var AreasAndLengthsParameters;
var Polygon;
var Circle;
var GeodesicUtils;
var WebMercatorUtils;
var GeometryEngine;
var Point;
var DrawPolygonComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DrawPolygonComponent, _super);
    function DrawPolygonComponent(_vcr, cdr, layerService, printService) {
        var _this = _super.call(this, _vcr) || this;
        _this.cdr = cdr;
        _this.layerService = layerService;
        _this.printService = printService;
        _this.drawComplete = new EventEmitter();
        _this.drawLayer = new EventEmitter();
        _this.showSettings = {
            createLayerForEachGraphic: true,
            type: true,
            mode: true,
            fillStyle: true,
            fillColor: true,
            outlineStyle: true,
            outlineColor: true,
            outlineWidth: true,
            areaUnit: true
        };
        _this.defaultSymbolProperties = {
            type: 'simple-fill',
            color: 'purple',
            style: 'solid',
            outline: {
                color: 'white',
                style: 'solid',
                width: 1
            }
        };
        _this.fillStyleOptions = FillStyleOptions;
        _this.outlineStyleOptions = LineStyleOptions;
        _this.polygonTypes = [
            { value: 'polygon', name: 'Polygon', hybridable: true },
            { value: 'rectangle', name: 'Rectangle' },
            { value: 'circle', name: 'Circle' },
            { value: 'rectangle', name: 'Arrow' }
        ];
        _this.selectedPolygonType = _this.polygonTypes[0];
        _this.polygonModes = [
            { value: 'click', name: 'Click', description: 'Vertices are added when the pointer is clicked.' },
            { value: 'freehand', name: 'Freehand', description: 'Vertices are added while the pointer is dragged.' },
            { value: 'hybrid', name: 'Hybrid', description: 'Vertices are added while the pointer is clicked or dragged.' }
        ];
        _this.selectedPolygonMode = _this.polygonModes[0];
        _this.areaUnits = [
            { name: 'None', value: null },
            { name: 'Acres', value: 'acres' },
            { name: 'Square Feet', value: 'square-feet' },
            { name: 'Square Miles', value: 'square-miles' },
            { name: 'Square Meters', value: 'square-meters' },
            { name: 'Square Kilometers', value: 'square-kilometers' }
        ];
        _this.selectedAreaUnit = _this.areaUnits[0];
        _this.initializing = false;
        _this.listners = [];
        return _this;
    }
    Object.defineProperty(DrawPolygonComponent.prototype, "enabled", {
        set: function (enabled) {
            this._enabled = enabled;
            if (this._enabled) {
                this.setupHandleHiddenLayer();
                this.createPolygonDrawAction();
            }
            else {
                this.draw.reset();
                this.teardownHandleHiddenLayer();
                if (this.graphic) {
                    this.mapView.graphics.remove(this.graphic);
                }
                this.cdr.detectChanges();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DrawPolygonComponent.prototype, "isLineStyleSupportedForPrinting", {
        get: function () {
            return this.printService.validateServerSideLayerStyle(this.symbolProperties.outline.style);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DrawPolygonComponent.prototype, "replacementLineStyle", {
        get: function () {
            return this.printService.getSupportedLineStyle(this.symbolProperties.outline.style).replace('-', ' ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DrawPolygonComponent.prototype, "colorPickerRef", {
        set: function (el) { this.colorPicker = el; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DrawPolygonComponent.prototype, "outlineColorPickerRef", {
        set: function (el) { this.outlineColorPicker = el; },
        enumerable: true,
        configurable: true
    });
    DrawPolygonComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, err_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, 4, 5]);
                        this.createLayerForEachGraphic = true;
                        this.symbolProperties = this.defaultSymbolProperties;
                        _b = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _b.mapView = _c.sent();
                        return [4 /*yield*/, Promise.all([
                                ESRI.Draw,
                                ESRI.Graphic,
                                ESRI.GeometryService,
                                ESRI.AreasAndLengthsParameters,
                                ESRI.Polygon,
                                ESRI.Circle,
                                ESRI.GeodesicUtils,
                                ESRI.WebMercatorUtils,
                                ESRI.GeometryEngine,
                                ESRI.Point
                            ])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 10]), Draw = _a[0], Graphic = _a[1], GeometryService = _a[2], AreasAndLengthsParameters = _a[3], Polygon = _a[4], Circle = _a[5], GeodesicUtils = _a[6], WebMercatorUtils = _a[7], GeometryEngine = _a[8], Point = _a[9];
                        this.draw = new Draw({ view: this.mapView });
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _c.sent();
                        this.readyProblem(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DrawPolygonComponent.prototype.createPolygonDrawAction = function () {
        var _this = this;
        var action = this.draw.create(this.selectedPolygonType.value, { mode: this.selectedPolygonMode.value });
        action.on(['vertex-add', 'vertex-remove', 'cursor-update'], function (evt) {
            _this.graphic = _this.createPolygonGraphic(evt.vertices);
            _this.mapView.graphics.add(_this.graphic);
        });
        action.on('draw-complete', function (evt) {
            var completedGraphic = _this.createPolygonGraphic(evt.vertices);
            _this.addPolygonGraphic(completedGraphic);
            _this.drawComplete.emit(completedGraphic);
            _this.reset();
        });
    };
    DrawPolygonComponent.prototype.createPolygonGraphic = function (vertices) {
        if (vertices.length > 1 && this.graphic) {
            this.mapView.graphics.remove(this.graphic);
        }
        var polygon = new Polygon({ spatialReference: this.mapView.spatialReference, rings: [vertices] });
        var nonPolygonVerticiesLength = 2;
        if (vertices.length === nonPolygonVerticiesLength) {
            var _a = tslib_1.__read(vertices[0], 2), startX = _a[0], startY = _a[1];
            var _b = tslib_1.__read(vertices[1], 2), endX = _b[0], endY = _b[1];
            var length_1 = this.getLength(polygon);
            switch (this.selectedPolygonType.value) {
                case 'rectangle':
                    if (this.selectedPolygonType.name === 'Arrow') {
                        polygon.rings = this.createArrowVerticies(startX, startY, endX, endY, length_1);
                    }
                    else {
                        polygon.rings = [[
                                [startX, startY],
                                [endX, startY],
                                [endX, endY],
                                [startX, endY],
                                [startX, startY]
                            ]];
                    }
                    break;
                case 'circle':
                    polygon = new Circle({
                        spatialReference: this.mapView.spatialReference,
                        center: { x: startX, y: startY, spatialReference: this.mapView.spatialReference },
                        radius: length_1
                    });
                    break;
                default:
                    break;
            }
        }
        var graphic = new Graphic({
            geometry: polygon,
            symbol: this.symbolProperties
        });
        return graphic;
    };
    DrawPolygonComponent.prototype.getLength = function (polygon) {
        length = GeodesicUtils.geodesicLengths([WebMercatorUtils.webMercatorToGeographic(polygon)])[0];
        return length + (length / RadiusOffsetDivisor);
    };
    DrawPolygonComponent.prototype.createArrowVerticies = function (startX, startY, endX, endY, length) {
        var radsMultiplyer = 2;
        var halfDegrees = 180;
        var widthDivisor = 0.2;
        var halfPositionDivisor = 2;
        var end = new Point({ x: startX, y: startY, spatialReference: this.mapView.spatialReference });
        var start = new Point({ x: endX, y: endY, spatialReference: this.mapView.spatialReference });
        var dx = end.x - start.x;
        var dy = end.y - start.y;
        var rads = Math.atan2(dx, dy);
        if (rads < 0) {
            rads = Math.abs(rads);
        }
        else {
            rads = radsMultiplyer * Math.PI - rads;
        }
        var degrees = rads * halfDegrees / Math.PI;
        var width = widthDivisor * length;
        var bottomLeft = [start.x - width / halfPositionDivisor, start.y];
        var bottomRight = [start.x + width / halfPositionDivisor, start.y];
        var midLeft = [bottomLeft[0], [bottomLeft[1] + length - width]];
        var midRight = [bottomRight[0], [bottomRight[1] + length - width]];
        var edgeLeft = [midLeft[0] - width / halfPositionDivisor, midLeft[1]];
        var edgeRight = [midRight[0] + width / halfPositionDivisor, midRight[1]];
        var point = [start.x, start.y + length];
        var poly = new Polygon({
            rings: [
                [
                    point,
                    edgeLeft,
                    midLeft,
                    bottomLeft,
                    bottomRight,
                    midRight,
                    edgeRight,
                    point
                ]
            ],
            spatialReference: this.mapView.spatialReference
        });
        var rotatedPoly = GeometryEngine.rotate(poly, degrees, start);
        return rotatedPoly.rings;
    };
    DrawPolygonComponent.prototype.addPolygonGraphic = function (graphic) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var title, result, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.graphicsLayer || this.createLayerForEachGraphic)) return [3 /*break*/, 4];
                        title = this.selectedPolygonType.name;
                        if (this.selectedPolygonMode.value === 'freehand') {
                            title = this.selectedPolygonMode.name + " " + title;
                        }
                        if (!this.selectedAreaUnit.value) return [3 /*break*/, 2];
                        this.isLoading = true;
                        if (!this.geometryService) {
                            this.geometryService = new GeometryService({ url: environment.geometryServiceUrl });
                        }
                        return [4 /*yield*/, this.geometryService.areasAndLengths(new AreasAndLengthsParameters({
                                areaUnit: this.selectedAreaUnit.value,
                                calculationType: 'preserve-shape',
                                lengthUnit: 'meters',
                                polygons: [graphic.geometry]
                            }))];
                    case 1:
                        result = _b.sent();
                        if (result && result.areas.length) {
                            title += " - " + result.areas[0] + " " + this.selectedAreaUnit.name;
                        }
                        this.isLoading = false;
                        this.cdr.detectChanges();
                        _b.label = 2;
                    case 2:
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: title, graphicLayer: 'polygon' })];
                    case 3:
                        _a.graphicsLayer = _b.sent();
                        _b.label = 4;
                    case 4:
                        this.graphicsLayer.add(graphic);
                        this.drawLayer.emit(this.graphicsLayer);
                        this.graphic = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    DrawPolygonComponent.prototype.reset = function () {
        this.draw.reset();
        this.polygonModes.find(function (mode) { return mode.value === 'hybrid'; }).disabled = !this.selectedPolygonType.hybridable;
        if (this.selectedPolygonMode.value === 'hybrid' && !this.selectedPolygonType.hybridable) {
            this.selectedPolygonMode = this.polygonModes[0];
        }
        this.createPolygonDrawAction();
    };
    DrawPolygonComponent.prototype.setupHandleHiddenLayer = function () {
        var _this = this;
        this.initializing = true;
        var stopInitialCheck = util.debounce(function () { _this.initializing = false; }, initilizeDebounceTime);
        this.listners.push(this.layerService.mapRef.allLayers.on('before-add', function (event) {
            if (_this.initializing && event.item.listMode === 'hide') {
                event.item.set('hideInLegend', true);
                event.item.set('drawPolygonToolGeneratedLayer', true);
                stopInitialCheck();
            }
        }));
        this.listners.push(this.layerService.mapRef.allLayers.on('after-remove', function (event) {
            if (event.item.get('drawPolygonToolGeneratedLayer')) {
                _this.initializing = true;
            }
        }));
    };
    DrawPolygonComponent.prototype.teardownHandleHiddenLayer = function () {
        while (this.listners.length) {
            this.listners.pop().remove();
        }
    };
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object)
    ], DrawPolygonComponent.prototype, "defaultSymbolProperties", void 0);
    return DrawPolygonComponent;
}(BaseComponent));
export { DrawPolygonComponent };
